import { render } from "./ExamDataCenterDetail.vue?vue&type=template&id=2f325652&scoped=true"
import script from "./ExamDataCenterDetail.vue?vue&type=script&lang=js"
export * from "./ExamDataCenterDetail.vue?vue&type=script&lang=js"

import "./ExamDataCenterDetail.vue?vue&type=style&index=0&id=2f325652&lang=less&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f325652"]])

export default __exports__